// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthManagerDashboard\ServicesDashboardResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';

// ServicesDashboardResponseData is the class that ServicesDashboardResponse serializes to/from
export interface ServicesDashboardResponseData {
    Date : /* ISO8601 */ string;
    OrganizationId : number;
	
    Services : TopicCardData[] | null;
	
}

// ServicesDashboardResponseOptions is the class which may be passed to the ServicesDashboardResponse constructor to define optional initial data values
export interface ServicesDashboardResponseOptions {
    Date : /* ISO8601 */ string;
    OrganizationId : number;
	
    Services? : TopicCardOptions[] | null;
	
}

export class ServicesDashboardResponse {
    public Date : DataSignal<TZDate>;
    public OrganizationId : DataSignal<number>;
	
    public Services : SDataArray<TopicCard>;
	

    constructor();
    constructor(data : ServicesDashboardResponseOptions);
    constructor(data: ServicesDashboardResponseOptions | null = null) {
        this.Date = jsonableObservable(S.value<TZDate>(data && data.Date !== undefined ? new TZDate(data.Date) : new TZDate(0), TZDate.eq));
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.Services = SArray<TopicCard>([]);
	    
    }

    static key(obj : ServicesDashboardResponse) {
        return obj.Date().toJSON() + '\u2618' + obj.OrganizationId();
    }
    
    static dataKey(obj : ServicesDashboardResponseOptions) {
        return new TZDate(obj.Date).toJSON() + '\u2618' + obj.OrganizationId;
    }

    static update(obj : ServicesDashboardResponse, data : ServicesDashboardResponseOptions) {
        S.freeze(() => {
            if (data.Date !== undefined) obj.Date(new TZDate(data.Date));
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ServicesDashboardResponse.ts